import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Fade from '@mui/material/Fade'

const ImageSlider = ({ images, imageRoot }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [loadedIndices, setLoadedIndices] = useState(new Set())
  const aspectRatio = 0.572
  const width = Math.min(320, window.innerWidth)

  useEffect(() => {
    if (images.length === 0) return
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length)
    }, 2000)
    return () => clearInterval(interval)
  }, [images.length])

  useEffect(() => {
    const newLoaded = new Set()
    for (let i = -2; i <= 3; i++) {
      const idx = (currentIndex + i + images.length) % images.length
      newLoaded.add(idx)
    }
    setLoadedIndices(newLoaded)
  }, [currentIndex, images.length])

  return (
    <Box sx={{ position: 'relative', width, height: Math.round(width / aspectRatio), overflow: 'hidden', float: 'right' }}>
      {images.map((image, index) => (
        <Fade in={index === currentIndex} timeout={500} key={index}>
          <Box
            component='img'
            src={loadedIndices.has(index) ? `${imageRoot}${image}` : undefined}
            alt={`Slide ${index + 1}`}
            sx={{
              position: 'absolute',
              top: -5,
              // left: '-5px',
              width: '100%',
              height: 'calc(100% + 52px)',
              objectFit: 'cover'
            }}
          />
        </Fade>
      ))}
    </Box>
  )
}

export default ImageSlider
